import React, {useRef, useState, useLayoutEffect} from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import useResizeObserver from "hooks/useResizeObserver";
import FauxHeaderDropdown from "components/Shared/FauxHeader/FauxHeaderDropdown";
import FauxHeaderInline from "components/Shared/FauxHeader/FauxHeaderInline";

const FauxHeader = ({
  headerVisible,
  title,
  dropdownTitle,
  children
}) => {
  const [
    {
      childrenContainerWidthAtCollapse,
      dropdownActive,
    },
    setState
  ] = useState({
    childrenContainerWidthAtCollapse: null,
    dropdownActive: false,
  });
  const childrenContainerRef = useRef();
  const {
    width: childrenContainerWidth,
  } = useResizeObserver(childrenContainerRef, [dropdownActive]);
  const childrenRef = useRef();
  const {
    width: childrenWidth,
  } = useResizeObserver(childrenRef, [dropdownActive]);
  useLayoutEffect(
    () => (
      (    
        childrenContainerWidthAtCollapse ? (
          childrenContainerWidthAtCollapse < childrenContainerWidth
        ) : (
          childrenWidth < childrenContainerWidth
        ) 
      ) === dropdownActive
    ) ? (
      setState({
        childrenContainerWidthAtCollapse: dropdownActive ? null : childrenContainerWidth,
        dropdownActive: !dropdownActive,
      })
    ) : (
      () => {}
    ),
    [childrenContainerWidth, childrenWidth]
  );
  return headerVisible ? (
    null
  ) : (
    <div className={"FauxHeader-Root"}>
      <div className={"FauxHeader-Title"}>{title}</div>
      <div ref={childrenContainerRef} className={"FauxHeader-ChildrenContainer"}>
        <div ref={childrenRef} className={"FauxHeader-Children"}>
          {dropdownActive ? (
            <FauxHeaderDropdown title={dropdownTitle || title}>
              {children}
            </FauxHeaderDropdown>
          ) : (
            <FauxHeaderInline>
              {children}
            </FauxHeaderInline>
          )}
        </div>
      </div>
    </div>
);
};

FauxHeader.defaultProps = {
  title: "",
  dropdownTitle: null,
};

FauxHeader.propTypes = {
  headerVisible: PropTypes.bool,
  title: PropTypes.string,
  dropdownTitle: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
};

const mstp = state => ({
  headerVisible: state.layout.coreLayoutSettings.headerVisible,
});

export default connect(mstp)(FauxHeader);